import { loadable } from 'utils';

export * as EarlyPaymentDiscount from './EarlyPaymentDiscount';
export * as InstitutionContract from './InstitutionContract';
export * as InstitutionContractGroup from './InstitutionContractGroup';
export * as InstitutionContractTemplate from './InstitutionContractTemplate';
export * as InstitutionEnrollment from './InstitutionEnrollment';
export * as InstitutionEnrollmentTemplate from './InstitutionEnrollmentTemplate';
export * as InstitutionStudent from './InstitutionStudent';
export * as InstitutionStore from './InstitutionStore';

export const ClassGroup = loadable(() => import('./ClassGroup'), {});
export const CollectionNotification = loadable(() => import('./CollectionNotification'), {});
export const Configuration = loadable(() => import('./Configuration'), {});
export const Course = loadable(() => import('./Course'), {});
export const CourseCapacity = loadable(() => import('./CourseCapacity'), {});
export const Grade = loadable(() => import('./Grade'), {});
export const Installation = loadable(() => import('./Installation'), {});
